import React, { useEffect } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getBusinessesAPI } from "../actions/business";
import { S3_URL } from '../api';

const useStyles = makeStyles(theme => ({
  root: {
    height: '70vh',
    marginTop: '10vh',
    marginBottom: '20vh'
  },
  profile: {
    color: '#000000',
    textDecoration: 'none'
  },
  profileMedia: {
    backgroundColor: 'rgba(0,0,0,0.06)',
    borderRadius: '50%',
    width: 250,
    height: 250,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.04)'
    },
    boxShadow: '4px 4px 8px rgba(0,0,0,0.25)'
  },
  profileImage: {
    width: '90%',
    height: '90%',
    objectFit: 'contain'
  }
}));


function BusinessProfile(props) {
  const { business } = props;
  const classes = useStyles();

  return (
    <Link
      to={`/business/${business.url ? business.url : business.id}`}
      className={classes.profile}
    >
      <div className={classes.profileMedia}>
        {business.logo &&
          <img
            alt={business.name}
            src={`${S3_URL}/businesses/${business.id}/${business.logo}`}
            className={classes.profileImage}
          />}
      </div>

      <Typography variant='h4'>
        {business.name}
      </Typography>
    </Link>
  )
}

function ChooseBusiness() {
  const businesses = useSelector(state => state.businesses.list);
  const classes = useStyles();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBusinessesAPI());
  }, [dispatch]);

  return (
    <Grid
      container
      spacing={2}
      alignContent='center'
      justify='center'
      className={classes.root}
    >
      {businesses.map(business => (
        <BusinessProfile key={business.id} business={business} />
      ))}
    </Grid>
  );
}

export default ChooseBusiness;